module.exports = __webpack_public_path__ + "img/screenBackNameNormal.6e7cf5db.png";